import { render } from "./FirstTimersColumnchart.vue?vue&type=template&id=1a25483c"
import script from "./FirstTimersColumnchart.vue?vue&type=script&lang=js"
export * from "./FirstTimersColumnchart.vue?vue&type=script&lang=js"

import "./FirstTimersColumnchart.vue?vue&type=style&index=0&id=1a25483c&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__